import IndicatorChartWidget from './IndicatorChartWidget';
import LevelWidget from './LevelWidget';
import ObjectiveWidget from './ObjectiveWidget';
import OpportunitiesWidget from './OpportunitiesWidget';
import StateWidget from './StateWidget';
import ValueCardWidget from './ValueCardWidget';

// Widget type -> renderer.
//
// This is deliberately a leaf module, separate from `widgetTypes`: `Content/Widget`
// renders from here, and the wizard steps render `Content/Widget` for their live
// preview. Anything that imports a wizard step must therefore stay out of this file
// or the import graph becomes circular.
export const widgetComponents = {
    indicator_chart: IndicatorChartWidget,
    level: LevelWidget,
    objective: ObjectiveWidget,
    opportunities: OpportunitiesWidget,
    state: StateWidget,
    value_card: ValueCardWidget
};
